import { Helmet } from "react-helmet-async";
import { SEO_CONFIG, type SEOPage } from "@/lib/seo";

interface SEOHeadProps {
  page: SEOPage;
  customTitle?: string;
  customDescription?: string;
  customImage?: string;
  canonicalUrl?: string;
}

const SEOHead = ({ page, customTitle, customDescription, customImage, canonicalUrl }: SEOHeadProps) => {
  const config = SEO_CONFIG[page];
  const defaults = SEO_CONFIG.default;

  const title = customTitle || config.title;
  const description = customDescription || config.description;
  const image = customImage || ("image" in config ? config.image : defaults.image);
  const url = canonicalUrl || ("url" in config ? config.url : defaults.url);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Flexaura" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEOHead;
